module.exports = __webpack_public_path__ + "5f3bd69a85f6c91f88132e469ab2298b.svg";